import n from '../../../../../../../../external/rollup-plugin-styles/dist/runtime/inject-css.js';
var css = ".monaco-workbench .notebookOverlay .monaco-editor .contentWidgets .empty-editor-hint{cursor:auto}";
n(css,{});
export { css, css as default };
